enum ContactTypeEnums {
	rent = "rent", // Buchung anfragen
	sale = "sale", // Expose anfragen
	kontakt = "kontakt" // Kontaktformular
	//   contact_rent = "contact_rent", // Kontaktformular bei klick auf den Brief unter “Buchung anfragen”
	//   contact_sale = "contact_sale" // Kontaktformular bei Klick auf den Brief unter “Expose anfragen”
}

export default ContactTypeEnums;
